module.exports = __webpack_public_path__ + "img/banner_bg.2e5a9f33.webp";